import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (<>
    <Helmet>
       <link rel="canonical" href="/"/>
       <title>404: This page could not be found</title>
   </Helmet>

    <Container fluid className="d-flex justify-content-center align-items-center Error_page" style={{backgroundColor:"#ededed"}}>
      <Row className="text-center my-0 my-md-3 py-0 py-md-3">
        <Col>
          <div className="my-5 py-md-5 py-3">
            <h1 className="display-1 fw-bolder text-black">404</h1>
            <h3 className="mb-md-2 mb-2 text-black fw-bolder">Oops! Page Not Found</h3>
            <p className="lead mb-3 mb-md-4 text-black">
              The page you are looking for does not exist.
            </p>
            <Link to="/">
              <Button size="lg" className='px-5' style={{backgroundColor:"#003e87", borderColor:"#003e87", color:"#fff", fontSize:"18px", fontWeight:"600"}}>Go to Home</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
    </>);
};

export default NotFound;
